import { Component, Input } from "@angular/core";

import { STRING } from "../../constants/string";

export type SizeType = "small" | "large" | "";
export type StateType = "hover" | "focus" | "";
export type SkinType = "white" | "red" | "yellow" | "green" | "gray" | "outline-white" | "outline-yellow" | "purple" | "text" | "text-purple" | "light-purple" | "";
export type ModeType = "icon" | "notification" | "";
export type BtnType = "button" | "reset" | "submit";

@Component({
  selector: "med-btn",
  templateUrl: "./med-btn.component.html",
  styleUrls: ["./med-btn.component.scss"],
})
export class MedBtnComponent {
  @Input() size: SizeType = "";
  @Input() skin: SkinType = "";
  @Input() mode: ModeType = "";
  @Input() state: StateType = "";
  @Input() type: BtnType = "button";
  @Input() disabled = false;
  @Input() rounded = false;

  get classList(): string {
    const rounded = this.rounded ? "rounded" : STRING.EMPTY;
    return [this.state, this.size, this.skin, this.mode, rounded].join(" ");
  }
}
